import type { ReactNode } from 'react'
import { OutlineButton } from './OutlineButton'

interface NoticeProps {
  children: ReactNode
  /** pending이면 버튼을 잠그되 자리는 그대로 둔다. 빼면 방금 누른 자리로 탭이 돌아올 곳을 잃는다. */
  action?: { label: string; onClick: () => void; pending?: boolean }
}

/**
 * 조용히 한 가지를 알리는 블록.
 *
 * 경고색을 쓰지 않고 surface 면과 ink 본문 색으로 둔다. 다음에 할 일이 있을 때만 버튼을 하나
 * 붙이고 둘 이상 두지 않는다.
 *
 * 막힌 일을 알리는 자리와 우리가 먼저 꺼내는 조용한 말이 같은 블록을 쓴다. 로그인이 막힌 것도
 * 새 자산이 나온 것도 사용자가 무엇을 잘못해서 뜨는 것이 아니라는 점이 같다.
 */
export function Notice({ children, action }: NoticeProps) {
  return (
    <div className="bg-surface border-border rounded-card flex flex-col gap-3.5 border px-[18px] py-4">
      <p className="text-ink text-[15px] leading-[1.7]">{children}</p>
      {action && (
        <div className="flex justify-end">
          <OutlineButton onClick={action.onClick} disabled={action.pending ?? false}>
            {action.label}
          </OutlineButton>
        </div>
      )}
    </div>
  )
}
